import React from "react";
import clsx from "clsx";
import * as styles from "./ShorexIcon.module.scss";
import { Icon, IconName } from "@silversea-ssc/ui-components-react";

interface ShorexIconProps {
  iconName: IconName;
  showDescription?: boolean;
  showLabel?: boolean;
  showLabelMobile?: boolean;
  className?: string;
  iconClassName?: string;
  size: "small" | "big";
  label: string;
  description: string | JSX.Element;
}

const ShorexIcon: React.FC<React.PropsWithChildren<ShorexIconProps>> = ({
  iconName,
  iconClassName = "",
  className = "",
  showDescription = false,
  showLabel = false,
  showLabelMobile = false,
  size,
  label,
  description
}) => {
  return (
    <div
      className={clsx(className, styles.container, {
        [styles.sizeBig]: size == "big",
        [styles.withDescription]: showDescription,
        [styles.withLabel]: showLabel,
        [styles.withShowLabelMobile]: showLabelMobile
      })}
      title={label || iconName}
    >
      <Icon
        name={iconName}
        className={clsx([iconClassName, styles.icon])}
        size="2x"
        padding="inline"
      />

      {(showLabel || showLabelMobile) && label && (
        <label className={styles.label}>{label}</label>
      )}
      {showDescription && description && <label>{description}</label>}
    </div>
  );
};

export default ShorexIcon;
